export default "__VITE_ASSET__BnTbchKF__"